<template>
  <div class="header" v-click-outside="hideAllPanels">
    <div class="header-main">
      <div class="top-wrapper">
        <div class="location-data-container">
          <div class="location-selector" @click="setShowLocationSelect(!showLocationSelect)">
            {{nodeInfo.value | truncateMaxChars}}
            <div class="location-toggle-icon"></div>
          </div>
          <div class="date-value">
            <!-- <span class="capitalize">{{currentDayString}}</span> {{t('date_connector_of')}} <span>{{currentMonthString}}</span> <span class="update-text"> - {{t('last_updated')}}</span> -->
            <span class="date-text">{{currentDateString}}</span><span class="update-text" v-if="isLatest"> - {{t('last_updated')}}</span>
          </div>
        </div>
        <template v-if="!isMobile">
          <StarIndicator v-show="showStarIndicator" :visible="true"/>
          <template v-if="isCompareMode">
            <div class="current-compare-node">
              <div class="compare-info">
                <!--<span class="label">{{t('comparando_con')}}</span>-->
                <div class="compare-name" @click="setShowCompareSelector(true)" v-if="compareNodeInfo">
                  {{compareNodeInfo.value}}
                  <div class="location-toggle-icon"></div>
                </div>
              </div>
              <div class="close-compare" @click="removeCompare"></div>
            </div>
          </template>
        </template>
        <div class="compare-toggle-icon" @click="setShowCompareSelector(!showCompareSelector)" :class="{'active': isCompareMode}"></div>
        <div class="date-selector-icon" @click="setShowDatePicker(!showDatePicker)"></div>
        <div class="indicators-menu-toggle-icon" @click="setShowIndicatorMenu(!showIndicatorMenu)"></div>
      </div>
    </div>
    <transition name="star-fade" v-if="isMobile">
        <StarIndicator v-show="showStarIndicator" :visible="true"/>
    </transition>
    <div class="current-compare-node" v-if="isCompareMode && isMobile">
      <div class="compare-info">
        <span class="label">{{t('comparando_con')}}</span>
        <div class="compare-name" @click="setShowCompareSelector(true)" v-if="compareNodeInfo">
          {{compareNodeInfo.value}}
          <div class="location-toggle-icon"></div>
        </div>
      </div>
      <div class="close-compare" @click="removeCompare"></div>
    </div>
    <transition name="panel-fade">
      <div class="location-search-panel panel" v-show="showLocationSelect">
        <div class="panel-content">
          <location-search @change="goToLocation" :showInline="!isMobile" :buttonLabel="nodeInfo.id?t('aplicar'):t('empezar')"></location-search>
        </div>
        <div class="panel-background" @click="setShowLocationSelect(false)"></div>
      </div>
    </transition>
    <transition name="panel-fade">
      <div class="indicator-menu-panel panel" v-show="showIndicatorMenu">
        <div class="panel-content">
          <div class="indicator-item" v-for="ind in indicatorList" @click="goToIndicator(ind.id)" :key="'link' + ind.id" :class="{'active': ind.id == current_ind}">
            {{t(ind.id)}}
          </div>
        </div>
        <div class="panel-background" @click="setShowIndicatorMenu(false)"></div>
      </div>
    </transition>
    <transition name="panel-fade">
      <div class="date-picker-panel panel" v-show="showDatePicker">
        <div class="panel-content">
          <date-picker v-model="current_date" is-inline is-required 
            :locale="this.$store.state.i18n.lang"
            :min-date="minDate"
            :max-date="maxDate"
          ></date-picker>
        </div>
        <div class="panel-background" @click="setShowDatePicker(false)"></div>
      </div>
    </transition>
    <transition name="panel-fade">
      <div class="compare-node-panel panel" v-show="showCompareSelector">
        <div class="panel-content">
          <compare-panel :showInline="!isMobile"></compare-panel>
        </div>
        <div class="panel-background" @click="setShowCompareSelector(false)"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import LocationSearch from '@/components/LocationSearch'
import ComparePanel from '@/components/ComparePanel'

import { mapState } from 'vuex'
import ClickOutside from 'vue-click-outside'
import StarIndicator from '@/components/IndicatorCards/StarIndicator'
import moment from 'moment';
import {truncateMaxChars, capitalize} from '@/utils/textUtils'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import {t} from '@/i18n'
import Api from '@/api'

export default {
  name: 'Header',
  components: {
    LocationSearch,
    StarIndicator,
    DatePicker,
    ComparePanel
  },
  data () {
    return {
      showLocationSelect: false,
      showIndicatorMenu: false,
      showDatePicker: false,
      showCompareSelector: false,
      current_ind: null,
      current_date: new Date(this.$store.state.nodeInfo.lastUpdate) //BASURA que no se pueda usar el mapState... pero creo que es "el orden de las cosas" (primero data, luego computeds)
    }
  },
  routerLinkedData: {
    current_ind: {},
    current_date:{
      getter () {
        return this.current_date.getTime()
      },
      setter (value) {
        this.current_date = new Date(+value || this.$store.state.nodeInfo.lastUpdate)
      }
    }
  },
  computed: {
    // currentDayString() {
    //   moment.locale(this.$store.state.i18n.lang);
    //   return moment(this.nodeInfo.lastUpdate).format('dddd D');
    // },
    // currentMonthString() {
    //   moment.locale(this.$store.state.i18n.lang);
    //   return moment(this.nodeInfo.lastUpdate).format('MMMM');
    // },
    minDate () {
      return new Date(this.$store.state.nodeInfo.firstDate)
    },
    maxDate () {
      return new Date(this.$store.state.nodeInfo.lastUpdate)
    },
    currentDateString() {
      moment.locale(this.$store.state.i18n.lang);

      let day = moment(this.current_date).format('dddd')
      let number = moment(this.current_date).format('D')
      let month = moment(this.current_date).format('MMMM')
      return `${capitalize(day)} ${number} ${t('date_connector_of')} ${capitalize(month)}`
    },
    isLatest(){
      return +this.current_date.getTime() === +this.nodeInfo.lastUpdate
    },
    showStarIndicator() {
      return !this.isCompareMode && this.current_ind && this.current_ind != 'trust'
    },
    ...mapState(['indicatorList', 'nodeInfo', 'compareNodeInfo'])
  },
  methods: {
    setShowLocationSelect (show) {
      this.hideAllPanels()
      this.showLocationSelect = show
    },
    setShowIndicatorMenu (show) {
      this.hideAllPanels()
      this.showIndicatorMenu = show
    },
    setShowDatePicker (show) {
      this.hideAllPanels()
      this.showDatePicker = show
    },
    setShowCompareSelector (show) {
      this.hideAllPanels()
      this.showCompareSelector = show
    },
    hideAllPanels() {
      this.showLocationSelect = false
      this.showIndicatorMenu = false
      this.showDatePicker = false
      this.showCompareSelector = false
    },
    goToIndicator(id){
      this.hideAllPanels()
      this.$emit('selectIndicator', id)
    },
    goToLocation(location) {
      //this.hideAllPanels()
      let preservedQuery = this.$route.query.current_date?{current_date:this.$route.query.current_date}:null
      location && this.$router.push({ path: `/${location.glk}/${location.id}`, query:preservedQuery})
    },
    removeCompare(){
      let query = Object.assign({}, this.$route.query)
      delete query.compare_node_id
      delete query.compare_node_glk
      this.$router.replace({ query })
    }
  },
  watch: {
    '$route.params.zoneId' () {
      this.hideAllPanels()
    },
    '$route.query.compare_node_id' () {
      this.hideAllPanels()
    },
    current_date () {
      this.showDatePicker = false
    }
  },
  filters: {
    truncateMaxChars
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="stylus" scoped>
$mobile-header-height = vh(70px)

.header
  position relative
  width 100%
  box-shadow 0 5px 6px rgba(0,0,0,0.1)
  .header-main
    align-items: center
    display: flex
    background #fff
    z-index: 3;
    position: relative;
    border-bottom: solid 1px #ddd; //no?
    .top-wrapper
      align-items: center
      display: flex
      height: $mobile-header-height
      padding: vh(10px) vh(15px)
      flex: 1 1 auto;
    .compare-toggle-icon
      margin-left auto
      height vw(20px)
      width vw(40px)
      cursor pointer
      background-image url('~@/assets/icons/compare.svg')
      background-size contain
      background-repeat: no-repeat;
      background-position: center center;
      &.active
        background-image url('~@/assets/icons/compare-blue.svg')

    .date-selector-icon
      margin 0 vw(20px)
      background-image url('~@/assets/icons/calendar.svg')
      background-size contain
      background-repeat: no-repeat;
      background-position: center center;
      height vw(20px)
      width vw(20px)
      cursor pointer

    .location-selector
      display flex
      align-items: center
      m-font-size(25,28)
      font-style italic
  
    .date-value
      m-font-size(12,15)
      margin-top vh(5px)
      font-family 'Lato'
      .update-text
        font-style italic

    .indicators-menu-toggle-icon
      // margin-left: auto
      background-image url('~@/assets/icons/dots.svg')
      background-size contain
      background-repeat: no-repeat;
      background-position: center center;
      height vw(7px)
      width vw(20px)
      cursor pointer
  .location-toggle-icon
    margin-left vw(7px)
    background-image url('~@/assets/icons/arrow-black.svg')
    background-size contain
    background-repeat: no-repeat;
    background-position: center center;
    height vw(20px)
    width vw(12px)
    cursor pointer
    &.up
      transform rotate(180deg)

  .current-compare-node
    display: flex
    height: $mobile-header-height
    padding: vh(10px) vh(15px)
    flex: 1 1 auto;
    align-items center
    .compare-info
      display flex
      flex-direction column
      .label
        m-font-size(11,12)
        font-weight $fw-semibold
      .compare-name
        display flex
        align-items: center
        color: $compare-color
        m-font-size(25,28)
        font-style italic
    .close-compare
      margin-left auto
      width vw(18px)
      height vw(18px)
      cursor pointer
      background-image url('~@/assets/icons/close-panel.svg')
      background-size contain
      background-repeat: no-repeat;
      background-position: center center;

  .panel
    position: absolute;
    top: $mobile-header-height
    box-shadow 0 5px 20px rgba(0,0,0,0.1)
    z-index: 2;
    visibility visible
    .panel-background
      background: rgba(0,0,0,0.6);
      height: 100vh;
      width: 100%;
      position: absolute;
      z-index -1
    .panel-content
      position: absolute;
      width: 100%
      background #fff
      box-shadow 0 5px 10px rgba(0,0,0,0.2)
      padding: vw(15px)

    &.panel-fade-enter-active, &.panel-fade-leave-active
      transition visibility .5s
      .panel-background
        transition opacity .5s
      .panel-content
        transition transform .5s

    &.panel-fade-enter, &.panel-fade-leave-to
      visibility hidden
      .panel-background
        opacity 0
      .panel-content
        transform translate(0,-100%)

  .location-search-panel, .compare-node-panel
    .panel-content
      background: #EDEDED
  .indicator-menu-panel
    background: #ffffff
    .panel-content
      margin-left: auto
      margin-right: vw(10px)
      display flex
      flex-direction column
      align-items center

      >>> .indicator-item
        cursor pointer
        margin vw(20px)
        font-family 'Lato'
        m-font-size(16,19)
        &.active
          color $bs-blue

  .mobile &
    display: flex;
    flex-direction: column;
    .header-main
      flex-direction column
      height: auto
      .top-wrapper
        display flex
        width: 100%;
        padding: vh(10px) vh(15px)
        border-bottom solid 1px #ddd
        // box-shadow: 0 1px 4px rgba(80,80,80,0.1);
    .star-indicator
      flex: 0 0 vh(70px);
      width: 100%;
      padding: vh(5px) vh(10px)
      // margin 0 vw(15px)
      z-index 1
      // PROVANDO
      position: absolute;
      top: 100%;
      height: 60%;
      background: #fff;
      box-shadow: 0 1px 4px rgba(80,80,80,0.2);

      &.star-fade-enter-active, &.star-fade-leave-active
        transition top .3s
        // overflow hidden
      &.star-fade-enter, &.star-fade-leave-to
        top 0px
        // padding: 0 vh(10px)
        // opacity 0
      >>> .indicator-content
        display flex
        width: 100%;
        flex-direction: row;

    .location-search-panel, .compare-node-panel
      // padding: vh(15px) vw(15px)
      width: 100%
    .indicator-menu-panel
      width 100vw
    .date-picker-panel
      // right: 0px;
      width: 100% //bastante guarro que no pueda ser "auto"....
      .vc-container
        margin auto
        border none
        min-width 100%
      width: 100%
      background #fff
  .desktop &
    .header-main
      .location-data-container
        // margin-right vw(30px)
        margin-right auto
      .top-wrapper
        padding: vh(5px) vw(40px)
      .star-indicator
        border-left 1px solid #cccccc
        padding: vh(0px) vh(15px)
        flex: 1 1 vw(400px);
        max-width vw(400px)
        height 100%
        >>> .indicator-content
          display flex
          width: 100%;
          flex-direction: column;
          .value-bar
            margin 0px
      .current-compare-node
        border-left 1px solid #cccccc
        padding: vh(0px) vh(15px)
        flex: 1 1 vw(400px);
        max-width vw(400px)
        height 100%

    .panel
      .panel-background
        display none
    .location-search-panel, .compare-node-panel
      background: #EDEDED
      // position absolute
      // top vh(80px)
      left 0px
      width: 100%
    .date-picker-panel
      right: 0px
      width: 300px
      .vc-container
        margin auto
        border none
    .indicator-menu-panel
      width: vw(280px)
      // position absolute
      // top vh(80px)
      right 0px
      .panel-content
        align-items flex-end
        .indicator-item
          margin vw(10px) vw(20px) vw(10px) vw(10px)
          m-font-size(14,16)
</style>

<style lang="stylus">
.vc-container
  font-family: 'Lato'
  .vc-highlight.vc-bg-blue-600
    background-color $bs-blue !important
</style>